import { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Drawer from 'react-modern-drawer';
import ReleaseService from "./ReleaseService";

export default function ViewContractReleaseAsset(param: any) {

    const [totalRows, setTotalRows] = useState(1);
    const [ViewAsset, initViewAsset] = useState<any[]>([]);

    let [ViewAssetHeader, setViewAssetHeader] = useState<any>([]);
    let [ViewAssetOriginal, setViewAssetOriginal] = useState<any>([]);
    let [ViewAssetVisibility, setViewAssetVisibility] = useState<any>([]);

    useEffect(() => {
        if (param.viewContract == true) {
            getApis()
        }
    }, [param]);

    let Data: any = {
        pageSize: 10,
        pageNumber: 1,
        assetType: ''
    }

    const getApis = () => {
        Data.assetType = param.type
        console.log(param)

        if (param.type === "release") {
            Data.releaseCode = param.viewContractSelect.catLogNumber
        }

        if (param.type === "song") {
            Data.releaseCode = param.viewContractSelect.intStdWorkCode
        }

        if (param.type === "track") {
            Data.isrc = param.viewContractSelect.iSRC
        }

        if (param.type === "projects") {
            Data.projectId = param.viewContractSelect.projectId
        }

        ReleaseService.listMyassetContractsRelease(Data).then((respond) => {
            setTotalRows(respond.totalRows)
            initViewAsset(CommonUtilities.relativeDataRemapping(respond.data, respond.headers.original));
            setViewAssetOriginal(CommonUtilities.objectreMap(respond.headers.original));
            setViewAssetHeader(CommonUtilities.objectreMap(respond.headers.display));
            setViewAssetVisibility(CommonUtilities.objectreMap(respond.headers.visible));
        })

    }

    const ViewContractReleaseChange = () => {
        param.ViewContractReleaseChange();
    }

    return (
        <div>


            <Drawer open={param.viewContract}
                onClose={ViewContractReleaseChange}
                direction='right'
                className='react-drawer'
                size={1000}>

                <div className="box ws-7 pull-right">

                    <div className="ws-12 box-header-main">
                        <h1 className="mlxl pull-left text-center">  List of Contract Assets for {param?.data?.catLogNumber} - ({totalRows}) records found</h1>

                        <a className="icon-btn primary btn-sm pull-right mtl" ><i className="icon-download1"></i> Export</a>
                    </div>

                    <div className="ws-12 box">
                        {totalRows > 0 && ViewAssetHeader && <table className="newTable allowHscroll allowVscroll ws-12">
                            <thead>
                                <tr>
                                    {ViewAssetHeader?.map((values: any, index: any) => {
                                        if (values !== 'totalRow' && ViewAssetVisibility[index] !== 0) {
                                            return (<>
                                                <th className="forceSingleLine">
                                                    <span className="forceSingleLine">{values} </span>
                                                </th>
                                            </>)
                                        }
                                    })}
                                </tr>
                            </thead>

                            <tbody>

                                {ViewAsset?.map((Datavalues: any, index: any) => {
                                    return (
                                        <tr>
                                            {ViewAssetOriginal?.map((values: any, index: any) => {
                                                if (values !== 'totalRow' && ViewAssetVisibility[index] === 1) {
                                                    return (<td >

                                                        {(() => {
                                                            if (typeof (Datavalues[values]) === "string") {
                                                                return (Datavalues[values])
                                                            }

                                                            if (typeof (Datavalues[values]) === "number") {
                                                                return (Datavalues[values].toFixed(2))
                                                            }

                                                        })()}

                                                    </td>)
                                                }
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>

                        </table>}
                    </div>

                    {totalRows == 0 && <div className="alert alert-info mt" >No contracts assets to display.</div>}

                    <div className="box-footer">
                        <button className="icon-btn delete width80 height35 pull-right" onClick={ViewContractReleaseChange}><i className="fa fa-close"></i> Close
                        </button>
                    </div>

                </div>

            </Drawer>

        </div>
    )


}




